import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=17ddf59a&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=17ddf59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddf59a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
